export default __webpack_public_path__ + "static/media/2.ffda2046.png";